import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOItem } from "../models/BOItem.model";
import { BOToothFaceType } from "../models/odo/BOToothFaceType.model";
import { BOToothStateType } from "../models/odo/BOToothStateType.model";


@Injectable({
  providedIn: 'root'
})
export class ToothStateTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ToothStateType';

    constructor(private http:HttpClient){}

    getAll():Observable<BOToothStateType[]>{
        return this.http.get<BOToothStateType[]>(this.myAppUrl + this.myApiUrl);
    }
}
